export const fetchRoles = (dispatch, getState, { api }) => {
  return api.get('/private/role/list');
}